function initializeDropzone() {

    var uploadIcon = site_url_wpml(true) + 'wp-content/plugins/missjones/public/images/mj-upload-icon.svg';
    var trashIcon = site_url_wpml(true) + 'wp-content/plugins/missjones/public/images/mj-trash-icon.svg';

    // Disabling autoDiscover, otherwise Dropzone will try to attach twice.
    Dropzone.autoDiscover = false;
    if (jQuery("#avatar-uploader").length) {
        jQuery("#avatar-uploader").dropzone({
            thumbnailWidth: 110,
            thumbnailHeight: 110,
            maxFilesize: 5, // MB
            maxFiles: 1,
            timeout: 0,
            url: dropParam.upload,
            acceptedFiles: 'image/*',
            dictDefaultMessage: `<div class='upload_box_content'><div class='upload_box_icon'><img src='${uploadIcon}'/></div>Click here to upload or drop media here<span>Image dimensions: 600x600 | Image size: max 5MB</span></div>`,

            init: function () {
                this.on("addedfile", file => {
                });
                this.on("processing", file => {
                    jQuery('.mj-current-avatar__display').hide();
                });
            }
            ,
            success: function (file, response) {
                file.previewElement.classList.add("dz-success");
                file['attachment_id'] = response; // push the id for future reference
                var ids = response;
                jQuery('#avatar-id').val(ids);
                //file.previewElement.remove();

                setTimeout(function () {
                    var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
                    cancelBtn.addClass('finished');
                    cancelBtn.html(`<div class="mj-cancel-upload"><img src='${trashIcon}'></div>`);
                }, 10);
            },

            renameFile: function (file) {
                let newName = new Date().getTime() + '-' + sanitizeFileName(file.name);
                return newName;
            },
            error: function (file, response) {
                file.previewElement.classList.add("dz-error");
                $(file.previewElement).find('.dz-error-message').text(response);
                setTimeout(function () {
                    var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
                    cancelBtn.addClass('finished');
                    cancelBtn.html(`<div class="mj-cancel-upload"><img src='${trashIcon}'></div>`);
                }, 10);
            },
            // update the following section is for removing image from library
            addRemoveLinks: true,
            removedfile: function (file) {
                var attachment_id = file.upload.filename;
                jQuery.ajax({
                    type: 'POST',
                    url: dropParam.delete,
                    data: {
                        media_id: attachment_id
                    }
                })
                    .success(function (data) {
                        var file = JSON.parse(data);
                        //alert(info);
                        var ids = jQuery('#avatar-id').val();
                        ids = ids.replace(file['message'], '');
                        jQuery('#avatar-id').val(data);
                    });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            }
        });
    }

    var venuePhotosUploader = initializeDropzoneUploads("#venue-photos-uploader", 10, 3, "#venue_uploads__preview_container", "#venue-photos-ids", "#venue-photos-total span", "venuePhotos", 'photo', 'Image dimensions: 2560x1440 | Image size: max 5MB');
    var venuePlansUploader = initializeDropzoneUploads("#venue-plans-uploader", 4, 50, "#venue_plans_uploads__preview_container", "#venue-plans-ids", "#venue-plans-total span", "venuePlans", 'file', 'Max file size: 50MB');
    var venueBrochuresUploader = initializeDropzoneUploads("#venue-brochures-uploader", 4, 50, "#venue_brochures_uploads__preview_container", "#venue-brochures-ids", "#venue-brochures-total span", "venueBrochures", 'file', 'Max file size: 50MB');

    var spacePhotosUploader = initializeDropzoneUploads("#space-photos-uploader", 10, 3, "#space_uploads__preview_container", "#space-photos-ids", "#space-photos-total span", "spacePhotos", 'photo', 'Image dimensions: 2560x1440 | Image size: max 5MB');
    var spacePlansUploader = initializeDropzoneUploads("#space-plans-uploader", 4, 50, "#space_plans_uploads__preview_container", "#space-plans-ids", "#space-plans-total span", "spacePlans", 'file', 'Max file size: 50MB');
    var spaceBrochuresUploader = initializeDropzoneUploads("#space-brochures-uploader", 4, 50, "#space_brochures_uploads__preview_container", "#space-brochures-ids", "#space-brochures-total span", "spaceBrochures", 'file', 'Max file size: 50MB');

    //Supplier
    var supplierPhotosUploader = initializeDropzoneUploads("#supplier-photos-uploader", 10, 3, "#supplier_uploads__preview_container", "#supplier-photos-ids", "#supplier-photos-total span", "supplierPhotos", 'photo', 'Image dimensions: 2560x1440 | Image size: max 10MB');
    var supplierBrochuresUploader = initializeDropzoneUploads("#supplier-brochures-uploader", 4, 50, "#supplier_brochures_uploads__preview_container", "#supplier-brochures-ids", "#supplier-brochures-total span", "supplierBrochures", 'file', 'Max file size: 50MB');

    if (jQuery("#space-photo-uploader").length) {
        jQuery("#space-photo-uploader").dropzone({
            thumbnailWidth: 110,
            thumbnailHeight: 110,
            maxFilesize: 5, // MB
            maxFiles: 10,
            timeout: 0,
            url: dropParam.upload,
            acceptedFiles: 'image/*',
            dictDefaultMessage: `<div class='upload_box_content'><div class='upload_box_icon'><img src='${uploadIcon}'/></div>Click here to upload or drop media here<span>Image dimensions: 2560x1440 | Image size: max 5MB</span></div>`,

            init: function () {
                this.on("addedfile", file => {
                });
                this.on("processing", file => {
                    jQuery('.mj-current-avatar__display').hide();
                });
            }
            ,
            success: function (file, response) {
                file.previewElement.classList.add("dz-success");
                file['attachment_id'] = response; // push the id for future reference

                var venuePrimaryValue = $("#venue_primary").val();
                var spacePhotoIdsInput = $('#space-photo-ids');

                var newUrl = response;

                if (venuePrimaryValue == 0) {
                    updateFilesContainerInputValues(spacePhotoIdsInput, newUrl, 'prepend');
                } else {
                    updateFilesContainerInputValues(spacePhotoIdsInput, newUrl, 'append');
                }

                setTimeout(function () {
                    var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
                    cancelBtn.addClass('finished');
                    cancelBtn.html(`<div class="mj-cancel-upload"><img src='${trashIcon}'></div>`);
                }, 10);
            },

            renameFile: function (file) {
                let newName = new Date().getTime() + '-' + sanitizeFileName(file.name);
                return newName;
            },
            error: function (file, response) {
                file.previewElement.classList.add("dz-error");
                $(file.previewElement).find('.dz-error-message').text(response);
                setTimeout(function () {
                    var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
                    cancelBtn.addClass('finished');
                    cancelBtn.html(`<div class="mj-cancel-upload"><img src='${trashIcon}'></div>`);
                }, 10);
            },
            // update the following section is for removing image from library
            addRemoveLinks: true,
            removedfile: function (file) {
                var attachment_id = file.upload.filename;
                jQuery.ajax({
                    type: 'POST',
                    url: dropParam.delete,
                    data: {
                        media_id: attachment_id
                    }
                })
                    .success(function (data) {
                        var fileData = JSON.parse(data);
                        var removedUrl = fileData['deleted_file'];

                        // Get the current value of #brochures-ids
                        var ids = jQuery('#space-photo-ids').val();

                        // Remove the specific URL associated with the removed file
                        ids = ids.replace(removedUrl, '');

                        // Remove leading and trailing commas
                        ids = ids.replace(/^,|,$/g, '');

                        // Update #brochures-ids with the modified value
                        jQuery('#space-photo-ids').val(ids);
                    });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            }
        });
    }


    if (jQuery("#brochures-uploader").length) {
        jQuery("#brochues-uploader").dropzone({
            thumbnailWidth: 234,
            thumbnailHeight: 56,
            maxFilesize: 20, // MB
            maxFiles: 4,
            timeout: 0,
            url: dropParam.upload_brochure,
            acceptedFiles: 'application/pdf',
            dictDefaultMessage: `<div class='upload_box_content'><div class='upload_box_icon'><img src='${uploadIcon}'/></div>Click here to upload or drop media here<span>File size: max 20MB</span></div>`,

            init: function () {
                this.on("addedfile", file => {
                });
                this.on("processing", file => {
                    //jQuery('.mj-current-avatar__display').hide();
                });
            }
            ,
            success: function (file, response) {
                file.previewElement.classList.add("dz-success");
                file['attachment_id'] = response; // push the id for future reference
                var existingIds = jQuery('#brochures-ids').val();
                var newUrl = response;

                if (existingIds) {
                    // If #brochures-ids already has a value, append the new URL with a comma
                    var updatedIds = existingIds + ',' + newUrl;
                    jQuery('#brochures-ids').val(updatedIds);
                } else {
                    // If #brochures-ids is empty, set it to the new URL directly
                    jQuery('#brochures-ids').val(newUrl);
                }

                setTimeout(function () {
                    var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
                    cancelBtn.addClass('finished');
                    cancelBtn.html(`<div class="mj-cancel-upload"><img src='${trashIcon}'></div>`);
                }, 10);
            },

            renameFile: function (file) {
                let newName = new Date().getTime() + '-' + sanitizeFileName(file.name);
                return newName;
            },
            error: function (file, response) {
                file.previewElement.classList.add("dz-error");
                $(file.previewElement).find('.dz-error-message').text(response);
                setTimeout(function () {
                    var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
                    cancelBtn.addClass('finished');
                    cancelBtn.html(`<div class="mj-cancel-upload"><img src='${trashIcon}'></div>`);
                }, 10);
            },
            // update the following section is for removing image from library
            addRemoveLinks: true,
            removedfile: function (file) {
                var attachment_id = file.upload.filename;
                jQuery.ajax({
                    type: 'POST',
                    url: dropParam.delete_brochure,
                    data: {
                        media_id: attachment_id
                    }
                })
                    .success(function (data) {
                        var fileData = JSON.parse(data);
                        var removedUrl = fileData['deleted_file'];

                        // Get the current value of #brochures-ids
                        var ids = jQuery('#brochures-ids').val();

                        // Remove the specific URL associated with the removed file
                        ids = ids.replace(removedUrl, '');

                        // Remove leading and trailing commas
                        ids = ids.replace(/^,|,$/g, '');

                        // Update #brochures-ids with the modified value
                        jQuery('#brochures-ids').val(ids);
                    });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            }
        });
    }
}

initializeDropzone();

jQuery(document).on('click', '.mj-cancel-upload-manual', function () {
    // Retrieve the value of data-src-file attribute using jQuery data() method
    var target = jQuery(this);

    var attachment_id = target.data('src-file');

    if (jQuery("#venue_primary").val() == 0) {
        var previewContainer = target.closest('.uploads__preview_container');
        var targetElement = target.closest('.uploaded_file');

        // Check if the ancestor is found
        if (previewContainer.length) { // Use .length to check if the jQuery object is not empty

            var removedUrl = attachment_id;

            // Find the next immediate sibling with class uploads-ids-container
            var idsContainer = previewContainer.next();

            // Check if the sibling is found and has the required class
            if (idsContainer.length && idsContainer.hasClass('uploads-ids-container')) {

                var ids = idsContainer.val();
                var processedIds = removeURLFromIds(ids, removedUrl);

                // Update #venue-photos-ids with the modified value
                idsContainer.val(processedIds);
                saveUploadedFilesToSession(idsContainer.data("session-name"), idsContainer.val());

                jQuery(idsContainer.next().find('span')).text(getTotalUploadedFiles(processedIds));
                targetElement.remove();

            } else {
                showNotification("Error removing the item: " + removedUrl, 'error');
            }
        }

    } else {
        var pathSegments = attachment_id.split('/');
        var filename = pathSegments[pathSegments.length - 1];

        $.ajax({
            url: dropParam.delete,
            type: 'POST',
            data: {
                media_id: filename
            },
            success: function (response) {
                var fileData = JSON.parse(response);

                if (fileData.status === 'Success') {

                    var removedUrl = fileData['deleted_file'];

                    var previewContainer = target.closest('.uploads__preview_container');
                    var targetElement = target.closest('.uploaded_file');

                    // Check if the ancestor is found
                    if (previewContainer.length) { // Use .length to check if the jQuery object is not empty
                        // Find the next immediate sibling with class uploads-ids-container
                        var idsContainer = previewContainer.next();

                        // Check if the sibling is found and has the required class
                        if (idsContainer.length && idsContainer.hasClass('uploads-ids-container')) {

                            var ids = idsContainer.val();
                            var processedIds = removeURLFromIds(ids, removedUrl);

                            // Update #venue-photos-ids with the modified value
                            idsContainer.val(processedIds);
                            saveUploadedFilesToSession(idsContainer.data("session-name"), idsContainer.val());

                            jQuery(idsContainer.next().find('span')).text(getTotalUploadedFiles(processedIds));
                            targetElement.remove();

                        } else {
                            showNotification("Error removing the item: " + removedUrl, 'error');
                        }
                    }

                } else {
                    var removedUrl = attachment_id;

                    var previewContainer = target.closest('.uploads__preview_container');

                    var idsContainer = previewContainer.next('.uploads-ids-container');

                    var ids = idsContainer.val();
                    var processedIds = removeURLFromIds(ids, removedUrl);
                    var targetElement = target.closest('.uploaded_file');

                    // Update #venue-photos-ids with the modified value
                    idsContainer.val(processedIds);
                    saveUploadedFilesToSession(idsContainer.data("session-name"), idsContainer.val());

                    jQuery(idsContainer.next().find('span')).text(getTotalUploadedFiles(processedIds));
                    // Remove the previewElement from the DOM
                    targetElement.remove();
                }
            },
            error: function (xhr, status, error) {
                console.error('Error removing file', error);

                // Handle specific error cases if needed
                if (xhr.status === 400) {
                    showNotification('Invalid request. Please try again.', 'error');
                } else {
                    showNotification('An unexpected error occurred. Please try again later.', 'error');
                }
            }
        });
    }
});


jQuery('#mj-remove-avatar').on('click', function () {
    // Ask for confirmation
    var confirmation = window.confirm("Are you sure you want to remove your avatar?");

    if (confirmation) {
        // If user clicks 'OK', remove the avatar
        $('.mj-current-avatar__display').remove();
    } else {
        // If user clicks 'Cancel', do nothing
    }
});

function initializeDropzoneUploads(selector, maxFilesLimit, maxFileSize, previewContainerId, idsInputId, totalSpanId, sessionName, fileType, description, maxWidth = 2560, maxHeight = 1440) {
    
    var uploadIcon = site_url_wpml(true) + 'wp-content/plugins/missjones/public/images/mj-upload-icon.svg';
    var trashIcon = site_url_wpml(true) + 'wp-content/plugins/missjones/public/images/mj-trash-icon.svg';

    return jQuery(selector).dropzone({
        thumbnailWidth: 110,
        thumbnailHeight: 110,
        maxFilesize: maxFileSize,
        maxFiles: maxFilesLimit,
        timeout: 0,
        url: dropParam.upload,
        previewContainer: previewContainerId,
        acceptedFiles: (fileType === 'photo') ? 'image/*' : 'application/pdf',
        dictDefaultMessage: `<div class='upload_box_content'><div class='upload_box_icon'><img src='${uploadIcon}'/></div>Click here to upload or drop media here<span>" + description + "</span></div>`,

        init: function () {
            this.on("addedfile", file => {
                if (fileType === 'photo') {
                    const _this = this;
                    const image = new Image();
                    image.onload = function () {
                        if (this.width > maxWidth || this.height > maxHeight) {
                            _this.removeFile(file);
                            showNotification(`Image dimensions should not exceed ${maxWidth}x${maxHeight}px.`, "error");
                        }
                    };
                    image.src = URL.createObjectURL(file);
                }
            });

            this.on("processing", file => {
                if (getSessionUploadedFiles(sessionName).length < maxFilesLimit) {
                    jQuery(previewContainerId).append(file.previewElement);
                } else {
                    this.removeFile(file);
                    showNotification("You can't upload more than " + maxFilesLimit + " " + ((fileType === 'photo') ? 'images' : 'files') + ".", "error");
                }
            });
        },
        success: function (file, response) {
            file.previewElement.classList.add("dz-success");
            file['attachment_id'] = response;

            // var existingIds = jQuery(idsInputId).val();
            // var newUrl = response;

            // if (existingIds) {
            //     var updatedIds = existingIds + ',' + newUrl;
            //     jQuery(idsInputId).val(updatedIds);
            // } else {
            //     jQuery(idsInputId).val(newUrl);
            // }

            var venuePrimaryValue = $("#venue_primary").val();
            var fileIdsInput = $(idsInputId);

            var newUrl = response;

            if (venuePrimaryValue == 0) {
                updateFilesContainerInputValues(fileIdsInput, newUrl, 'prepend');
            } else {
                updateFilesContainerInputValues(fileIdsInput, newUrl, 'append');
            }

            all_images = saveUploadedFilesToSession(sessionName, fileIdsInput.val());
            jQuery(totalSpanId).text(getTotalUploadedFiles(jQuery(idsInputId).val()));

            setTimeout(function () {
                var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
                cancelBtn.addClass('finished');
                cancelBtn.html(`<div class="mj-cancel-upload"><img src='${trashIcon}'></div>`);
            }, 10);
        },
        renameFile: function (file) {
            let newName = new Date().getTime() + '-' + sanitizeFileName(file.name);
            return newName;
        },
        error: function (file, response) {
            showNotification(response, 'error');

            file.previewElement.classList.add("dz-error");
            jQuery(file.previewElement).find('.dz-error-message').text(response);
            // setTimeout(function () {
            //     var cancelBtn = jQuery(file.previewElement).find('.dz-remove');
            //     cancelBtn.addClass('finished');
            //     cancelBtn.html('<div class="mj-cancel-upload"><img src="./../wp-content/plugins/missjones/public/images/mj-trash-icon.svg"></div>');
            // }, 10);
        },
        addRemoveLinks: true,
        removedfile: function (file) {
            var attachment_id = file.upload.filename;
            jQuery.ajax({
                type: 'POST',
                url: dropParam.delete,
                data: {
                    media_id: attachment_id
                }
            })
                .success(function (data) {
                    var fileData = JSON.parse(data);
                    var removedUrl = fileData['deleted_file'];

                    var ids = jQuery(idsInputId).val();
                    var processedIds = removeURLFromIds(ids, removedUrl);

                    jQuery(idsInputId).val(processedIds);
                    saveUploadedFilesToSession(sessionName, jQuery(idsInputId).val());
                    jQuery(totalSpanId).text(getTotalUploadedFiles(processedIds));
                });

            var _ref;
            return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
        }
    });
}

function getTotalUploadedFiles(uploadedIDs) {
    let totalFiles = 0;

    if (uploadedIDs && uploadedIDs.trim() !== "") {
        const uploadedIDsArray = uploadedIDs.split(',').map(item => item.trim());
        totalFiles = uploadedIDsArray.length;
    }

    return parseInt(totalFiles, 10);
}

function removeURLFromIds(ids, removedUrl) {

    // Convert the value to an array separated by commas
    var idsArray = ids.split(',');

    // Remove the specific URL associated with the removed file
    var urlIndex = idsArray.indexOf(removedUrl);
    if (urlIndex !== -1) {
        idsArray.splice(urlIndex, 1);
    }

    // Convert the array back to a string separated by commas
    ids = idsArray.join(',');

    // Remove leading and trailing commas
    ids = ids.replace(/^,|,$/g, '');

    // Return the modified string
    return ids;
}

function saveUploadedFilesToSession(sessionName, ids) {
    var urlsArray = ids.split(',');
    // // Store file data in sessionStorage
    if (Array.isArray(urlsArray)) {
        sessionStorage.setItem(sessionName, JSON.stringify(urlsArray)); // Update in sessionStorage
        return sessionStorage.getItem(sessionName);
    }
}

function getSessionUploadedFiles(sessionName) {
    // Check if venuePhotos exists in sessionStorage
    if (sessionStorage.getItem(sessionName)) {
        // Retrieve it as an array, handling potential parsing errors
        return JSON.parse(sessionStorage.getItem(sessionName)) || [];
    } else {
        // Create an empty array and store it in sessionStorage
        sessionStorage.setItem(sessionName, JSON.stringify([]));
        return []; // Initialize the variable for later use
    }
}

function updateFilesContainerInputValues(inputElement, newValue, operation) {
    var existingIds = inputElement.val();
    if (existingIds) {
        if (operation === 'prepend') {
            var idArray = existingIds.split(',');
            idArray.unshift(newValue);
            inputElement.val(idArray.join(','));
        } else if (operation === 'append') {
            inputElement.val(existingIds + ',' + newValue);
        }
    } else {
        inputElement.val(newValue);
    }
}